import Sidebar from "./Sidebar"
import Filter from "./Filter"

class App extends React.Component {
  state = {
    filter: "foodType",
    filterClassification: "foodType",
    filteredTransporters: [],
    selections: [],
  }

  componentWillMount() {
    this.setState({ filteredTransporters: this.props.transporters })
  }

  setFilterFn = (options) => {
    if (options.choice === "reset") {
      this.resetFn()
    } else {
      this.setState({
        filter: options.nextFilter,
        filterClassification: options.filterClassification,
        selections: [...this.state.selections, options.choice],
      }, () => this.filterTransportersFn(options))
    }
  }

  resetFn = () => {
    this.setState({
      filter: "foodType",
      filterClassification: "foodType",
      filteredTransporters: this.props.transporters,
      selections: [],
    })
  }

  filterTransportersFn = (options) => {
    const matchingTransporters = []

    this.state.filteredTransporters.forEach((transporter) => {
      if (transporter[options.filterType] === options.choice) { matchingTransporters.push(transporter) }
    })
    this.setState({ filteredTransporters: matchingTransporters })
  }

  render() {
    return (
      <div>
        <div className="col-sm-3 left-page">
          <img
            src={"/assets/logo_build-a-transporter.png"}
            width="100%"
            className="img-responsive center-block logo hidden-xs"
          />
          <img
            src={"/assets/logo_build-a-transporter-mobile.png"}
            className="img-responsive center-block visible-xs"
          />
          <Sidebar
            selections={this.state.selections}
            restartFn={this.setFilterFn}
          />
        </div>
        <div className="col-sm-9 right-page">
          <Filter
            filter={this.state.filter}
            filterClassification={this.state.filterClassification}
            setFilterFn={this.setFilterFn}
            transporters={this.state.filteredTransporters}
          />
        </div>
      </div>
    )
  }
}

export default App
